/**
 * Global event emitter for session eviction.
 * Used by Apollo error link (which can't access React context) to notify the app
 * that the current session was evicted and the user needs to re-authenticate.
 */

type SessionEvictedListener = () => void;

let listener: SessionEvictedListener | null = null;

export const onSessionEvicted = (callback: SessionEvictedListener): (() => void) => {
  listener = callback;
  return () => {
    listener = null;
  };
};

export const emitSessionEvicted = (): void => {
  if (listener) {
    listener();
  }
};
